<ng-container *ngIf="mobileQuery.matches">
    <ng-container *ngTemplateOutlet="userProfile"></ng-container>
</ng-container>
<ng-content select="[beforePrimaryMenu]"></ng-content>
<div class="nav nav-bar d-flex "
    [ngClass]="{'align-items-center justify-content-center fh flex-fill':!mobileQuery.matches, 'flex-column justify-content-start':mobileQuery.matches}"
    *ngIf="logged">

    <mat-nav-list appAccordion class="nav--menu-header nav--menu-header-main d-flex flex-gap-8 "
        [ngClass]="{'flex-column justify-content-start':mobileQuery.matches, 'align-items-center': !mobileQuery.matches}">
        <mat-list-item *ngFor="let menuitem of menuHeader" routerLinkActive="selected disabled"
            class="w-auto nav--link-item">
            <ng-container *ngIf="menuitem.children; else menuNavItemT">
                <button mat-menu-item [matMenuTriggerFor]="getRef(menuitem)" class="nav--link">{{ menuitem.name |
                    translate }} </button>
            </ng-container>
            <ng-template #menuNavItemT>
                <!-- [state]="{menuUrl: menuitem.state,itemNew:menuitem.is_new}" -->
                <a [routerLink]="['./', menuitem.state]" *ngIf="menuitem.type === 'link'"
                    class="nav--link nav--routelink">
                    <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon }}</mat-icon>
                    <span>{{ menuitem.name | translate }}</span>
                    <span class="di di-mark-new  animation-glow" *ngIf="menuitem.is_new"></span>
                </a>
                <a href="{{menuitem.state}}" *ngIf="menuitem.type === 'url'" class="nav--link"
                    target="{{menuitem.target}}" [ngClass]="menuitem.classes">
                    <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon
                        }}</mat-icon>
                    <span>{{ menuitem.name | translate }}</span>
                    <span class="di di-mark-new  animation-glow" *ngIf="menuitem.is_new"></span>
                </a>
            </ng-template>
        </mat-list-item>
    </mat-nav-list>

</div>
<ng-content select="[afterPrimaryMenu]"></ng-content>
<div class="secondary-menu d-flex gap-8"
    [ngClass]="{'flex-column justify-content-start':mobileQuery.matches, 'align-items-center': !mobileQuery.matches}">
    <ng-content select="[beforeSecondaryMenu]"></ng-content>
    <!-- <ngx-shopping-cart ></ngx-shopping-cart> -->
    <!-- notifications module -->
    <div class="pl--24 pl--lg-0" *ngIf="logged">
        <ngx-mare-notifications></ngx-mare-notifications>
    </div>
    <!-- menu user -->
    <div class="nav nav-bar service-menu d-flex "
        [ngClass]="{'flex-column justify-content-start':mobileQuery.matches, 'align-items-center justify-content-center fh': !mobileQuery.matches}"
        #navMenuUser *ngIf="logged;else notlogged">
        <mat-nav-list appAccordion class="nav--menu-header nav--menu-header-main d-flex  flex-gap-8 "
            [ngClass]="{'flex-column justify-content-start':mobileQuery.matches, 'align-items-center': !mobileQuery.matches}">
            <mat-list-item *ngFor="let menuitem of menuUser" routerLinkActive="selected disabled"
                class="w-auto nav--link-item" matTooltip="{{ showMenuLabels ? '': menuitem.name}}">
                <ng-container *ngIf="menuitem?.children; else menuNavItemU">
                    <button mat-menu-item [matMenuTriggerFor]="getRef(menuitem)" class="nav--link">{{ menuitem.name |
                        translate }} </button>
                </ng-container>
                <ng-template #menuNavItemU>
                    <!-- [state]="{menuUrl: menuitem.state,itemNew:menuitem.is_new}" -->
                    <ng-container [ngSwitch]="menuitem.type">
                        <ng-container *ngSwitchCase="'link'">
                            <a [routerLink]="['./', menuitem.state]" class="nav--link nav--routelink">
                                <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon}}</mat-icon>

                                <ng-container *ngIf="showMenuLabels">
                                    <span>{{ menuitem.name | translate }}</span>
                                    <span class="di di-mark-new  animation-glow" *ngIf="menuitem.is_new"></span>
                                </ng-container>
                            </a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'info'">
                            <div class="nav--link d-flex gap-8" *ngIf="!mobileQuery.matches && currentUser && currentCompany" >
                                <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon }}</mat-icon>
                                <div class="user-info">
                                    <div class="company">{{ currentCompany.business_name }}</div>
                                    <div class="username">{{ currentUser.name }}</div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'url'">
                            <a href="{{menuitem.state}}" class="nav--link" target="{{menuitem.target}}"
                                [ngClass]="menuitem.classes">
                                <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon
                                    }}</mat-icon>
                                <ng-container *ngIf="showMenuLabels">
                                    <span>{{ menuitem.name | translate }}</span>
                                    <span class="di di-mark-new  animation-glow" *ngIf="menuitem.is_new"></span>
                                </ng-container>
                            </a>
                        </ng-container>
                        <ng-container *ngSwitchCase="'to-replace'">
                            <button mat-button class="nav--link" [ngClass]="menuitem.classes"
                                (click)="replace(menuitem.state)">
                                <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon}}</mat-icon>
                                <!-- <ng-container *ngIf="showMenuLabels"> -->
                                <span>{{ menuitem.name | translate }}</span>
                                <span class="di di-mark-new  animation-glow" *ngIf="menuitem.is_new"></span>
                                <!-- </ng-container> -->
                            </button>
                        </ng-container>



                    </ng-container>
                </ng-template>
            </mat-list-item>
        </mat-nav-list>
    </div>
    <ng-content select="[afterSecondaryMenu]"></ng-content>
</div>

<ng-container *ngIf="newMenues">
    <mat-menu class="{{menu.object_id}}" *ngFor="let menu of newMenues; let i = index" [id]="menu.object_id">
        <ng-container *ngFor="let menuitem of menu.children">
            <button mat-menu-item [matMenuTriggerFor]="getRef(menuitem)" *ngIf="menuitem.children"
                class="nav--link nav--dropdown">{{
                menuitem.name | translate }}</button>
            <ng-container *ngIf="!menuitem.children">
                <a mat-menu-item [routerLink]="['./', menuitem.state]" *ngIf="menuitem.type === 'link'"
                    class="nav--link nav--routelink">
                    <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon
                        }}</mat-icon>
                    <span>{{ menuitem.name | translate }}</span>
                    <span class="di di-mark-new animation-glow" *ngIf="menuitem.is_new"></span>
                </a>
                <a mat-menu-item href="{{menuitem.state}}" *ngIf="menuitem.type === 'url'" class="nav--link"
                    target="{{menuitem.target}}" [ngClass]="menuitem.classes">
                    <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon
                        }}</mat-icon>
                    <span>{{ menuitem.name | translate }}</span>
                    <span class="di di-mark-new animation-glow" *ngIf="menuitem.is_new"></span>
                </a>
            </ng-container>
        </ng-container>
    </mat-menu>
</ng-container>

<ng-template #userProfile>
    <div class="user-info-card d-flex gap-8 align-items-center" *ngIf="currentUser && currentCompany">
        <div class="user-initials">{{ userInitials }}</div>
        <div class="user-names d-flex flex-column gap-8">
            <div class="username">{{ userDisplayname }}</div>
            <div class="company text-primary">{{ currentCompany.business_name }}</div>
        </div>
    </div>
</ng-template>

<ng-template #notlogged>
    <span class="flex-fill"></span>
    <div class="nav nav-bar service-menu d-flex align-items-center justify-content-center fh"
        [class.hide]="mobileQuery.matches">
        <button mat-flat-button (click)="startLogin()" class="nav--link" color="accent">
            <mat-icon>login</mat-icon>
            <span>{{ 'login' | translate }}</span>
        </button>
        <!-- <mat-nav-list appAccordion
            class="nav--menu-header nav--menu-header-main d-flex align-items-center flex-gap-8 "
            >
            <mat-list-item 
                routerLinkActive="selected disabled"
                class="w-auto nav--link-item">
                <button mat-menu-item  (click)="startLogin()" class="nav--link" color="primary">
                    <span>{{ 'login' | translate }}</span>
                    <mat-icon>login</mat-icon> 
                </button>
            </mat-list-item>
        </mat-nav-list> -->
    </div>

</ng-template>

<!-- ============================================================== -->
<!-- Profile - style you can find in header.scss -->
<!-- ============================================================== -->

<ng-template #menuItem let-menuitem>
    <a mat-menu-item [routerLink]="['./', menuitem.state]" *ngIf="menuitem.type === 'link'" class="nav--link">
        <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon }}</mat-icon>
        <span>{{ menuitem.name | translate }}</span>
    </a>
    <!-- <a mat-list-item [routerLink]="['./', menuitem.state]" *ngIf="menuitem.type === 'link'"
            class="nav--routelink" [ngClass]="menuitem.classes">
            <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon }}</mat-icon>
            <span>{{ menuitem.name }}</span>
        </a> -->
    <a mat-menu-item href="{{menuitem.state}}" *ngIf="menuitem.type === 'url'" class="nav--link"
        target="{{menuitem.target}}" [ngClass]="menuitem.classes">
        <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon }}</mat-icon>
        <span>{{ menuitem.name | translate }}</span>
    </a>

</ng-template>

<ng-template #menuToggleItem let-menuitem>
    <button mat-button [matMenuTriggerFor]="itemMenu" class="nav--link">
        <mat-icon *ngIf="menuitem.icon">{{ menuitem.icon }}</mat-icon>
        <span>{{ menuitem.name }} </span>
    </button>
    <mat-menu #itemMenu="matMenu" xPosition="after">
        <ng-container *ngFor="let children of menuitem.children">
            <ng-container *ngTemplateOutlet="menuItem; context: { $implicit: children}"></ng-container>
        </ng-container>
    </mat-menu>

</ng-template>